module.exports = __webpack_public_path__ + "static/media/other.cfde977b.png";